import { render, staticRenderFns } from "./userDebug.vue?vue&type=template&id=22fbcb67&scoped=true"
import script from "./userDebug.vue?vue&type=script&lang=js"
export * from "./userDebug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fbcb67",
  null
  
)

export default component.exports